import { NEWPropertyOwnership, RepresentativeRole } from '../entity'

export const getOwner = (propertyOwnership: NEWPropertyOwnership) => {
  return propertyOwnership?.representatives?.find((rep) => rep.role === RepresentativeRole.OWNER)
}
